// extracted by mini-css-extract-plugin
module.exports = {"info-container":"styles_info-container__d92JH","infoContainer":"styles_info-container__d92JH","label":"styles_label__2iIQb"};